import * as React from 'react'
import { Input } from '@/components/ui/input'
import { cn } from '@/lib/utils'
import { OdinFormLabel } from '@/components/ui/odin/form/odin-form-label'
import { OdinFormDescription } from '@/components/ui/odin/form/odin-form-description'
import { OdinFormError } from '@/components/ui/odin/form/odin-form-error'

export type OdinInputProps = React.ComponentProps<'input'> & {
  label?: string
  description?: string
  error?: string
  required?: boolean
}

export function OdinInput({ className, label, description, error, required, id, placeholder, ...props }: OdinInputProps) {
  const reactId = React.useId()
  const inputId = id || `input-${reactId}`
  const errorId = inputId + '-error'
  return (
    <div className={cn('flex flex-col gap-1', className)}>
      {label && (
        <OdinFormLabel htmlFor={inputId} required={required}>
          {label}
        </OdinFormLabel>
      )}
      {description && <OdinFormDescription>{description}</OdinFormDescription>}
      {/* Starterkit-like density: raw base-nova inputs (h-8) read too thin, same call as OdinButton. */}
      <Input
        id={inputId}
        className="h-10 px-3"
        placeholder={placeholder ?? label}
        aria-invalid={!!error}
        aria-describedby={error ? errorId : undefined}
        {...props}
      />
      <OdinFormError error={error} id={errorId} />
    </div>
  )
}
